export const formBorrowerProperties = () => {
  if (process.env.NODE_ENV === 'development') {
    return {
      properties: {
        name: {
          type: 'string',
          title: 'Full name',
          default: 'Test User'
        },
        abn: {
          type: 'string',
          title: 'ABN or ACN',
          default: '12345'
        },
        businessName: {
          type: 'string',
          title: 'Registered business name',
          default: 'Test Organisation Pty Ltd'
        },
        businessType: {
          type: 'string',
          title: 'Type of business entity',
          enum: ['Sole Proprietor', 'Partnership', 'Public Company', 'Trustee Company', 'Association', 'Pty Ltd', 'Other'],
          default: 'Partnership'
        },
        website: {
          type: 'string',
          title: 'Website (if applicable)',
          default: 'youtube.com'
        },
        outstandingLiabilityPayments: {
          type: 'boolean',
          title: 'Do you the borrower(s) have any outstanding liabilities for taxes or other statutory payments (eg. GST, Group Tax, Superannuation etc)',
          default: false
        },
        pendingLegalAction: {
          type: 'boolean',
          title: 'Is there any legal action pending or in progress in relation to you, the borrower(s) or the business or which may affect the business (eg. Creditor action, administrator/liquidator appointment etc)',
          default: false
        },
        capacityToRepay: {
          type: 'boolean',
          title: 'Do the borrower(s) have the capacity to repay all current credit obligations in addition to the proposed obligations as docmented in this application?',
          dfault: false
        },
        existingBusinessFacilities: {
          type: 'string',
          title: 'Existing and requested business facilities',
          default: 'Test Biz Facility'
        },
        numberOfEmployees: {
          type: 'integer',
          title: 'Number of employees?',
          default: 50
        },
        businessAddress: {
          title: 'Business address',
          '$ref': '#/definitions/address'
        }
      },
      definitions: {
        address: {
          type: 'object',
          required: [ 'streetAddress', 'city', 'postcode', 'state' ],
          properties: {
            streetAddress: {
              title: 'Street address',
              type: 'string',
              default: '1 Borrower st'
            },
            city: {
              title: 'City',
              type: 'string',
              default: 'Borrower City'
            },
            postcode: {
              title: 'Postcode',
              maxLength: 4,
              type: 'string',
              default: '3000'
            },
            state: {
              title: 'State',
              type: 'string',
              enum: [
                'New South Wales', 'Victoria', 'Queensland', 'Western Australia',
                'South Australia', 'Tasmania', 'Australian Capital Territory', 'Northern Territory'
              ],
              default: 'Victoria'
            }
          },
        }
      }
    };
  }
  return {};
}



// WEBPACK FOOTER //
// ./src/fixtures/formBorrowerProperties.js